import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";


const TogetherForTheFutureSection = ({}) => {

    return (
        <div className="my-5 py-5 bg-dark-img">
            <div className="container">
                <div className='row'>
                    <div className='col-5'></div>
                    <div className='col-7 color-white bg-dark font-etihad translate-dynamic'>
                        <h3 className="font-bold color-white">Together for the future</h3>
                        <p>“On land and in the sea, our forefathers lived and survived in this environment. They were able to do so because they recognised the need to conserve it, to take from it only what they needed to live, and to preserve it for succeeding generations.” </p>
                        <p>Learn more about our approach to sustainability in the skies and on the ground <a className="font-bold color-white underline" target="_blank" href="https://www.etihadaviationgroup.com/content/dam/eag/corporate/etihadaviation/en-ae/desktop2/pdfs/EY6806_Sustainability_Infographic_V6.pdf">here</a>.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default TogetherForTheFutureSection;